/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { GraduatoriaAnteprimaEligibilitaDTO } from '../model/models';
import { GraduatoriaAnteprimaEligibilitaForm } from '../model/models';
import { GraduatoriaCanaliEsitoDTO } from '../model/models';
import { GraduatoriaComunicazioneSummaryDTO } from '../model/models';
import { GraduatoriaCreationForm } from '../model/models';
import { GraduatoriaListItemDTO } from '../model/models';
import { GraduatoriaResiduoDTO } from '../model/models';
import { GraduatoriaRicalcoloForm } from '../model/models';
import { GraduatoriaRigaDTO } from '../model/models';
import { GraduatoriaRigaPubblicazioneDTO } from '../model/models';
import { GraduatoriaScorrimentoDTO } from '../model/models';
import { GraduatoriaScorrimentoForm } from '../model/models';
import { GraduatoriaScorrimentoStatoDTO } from '../model/models';
import { GraduatoriaSnapshotDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelGraduatoriaRigaDTO } from '../model/models';
import { PagedModelGraduatoriaScorrimentoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AnnullaGraduatoriaRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
    version: number;
}

export interface AnteprimaEleggibilitaGraduatoriaRequestParams {
    idTipoPratica: string;
    graduatoriaAnteprimaEligibilitaForm: GraduatoriaAnteprimaEligibilitaForm;
}

export interface CalcolaGraduatoriaRequestParams {
    idTipoPratica: string;
    graduatoriaCreationForm: GraduatoriaCreationForm;
}

export interface ComunicaGraduatoriaEsitoRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
}

export interface ConfermaGraduatoriaRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
    version: number;
}

export interface EseguiGraduatoriaScorrimentoRequestParams {
    idTipoPratica: string;
    graduatoriaScorrimentoForm: GraduatoriaScorrimentoForm;
}

export interface ExportGraduatoriaRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
}

export interface ExportGraduatoriaPubblicazioneRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
}

export interface GetGraduatoriaCanaliEsitoRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
}

export interface GetGraduatoriaDettaglioRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
}

export interface GetGraduatoriaRigheRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
    pageable: Pageable;
}

export interface GetGraduatoriaScorrimentoRequestParams {
    idTipoPratica: string;
}

export interface ListGraduatoriaScorrimentiRequestParams {
    idTipoPratica: string;
    pageable: Pageable;
}

export interface ListGraduatorieRequestParams {
    idTipoPratica: string;
}

export interface ListGraduatorieResiduiRequestParams {
    idTipoPratica: string;
}

export interface RicalcolaGraduatoriaRequestParams {
    idTipoPratica: string;
    idGraduatoria: string;
    graduatoriaRicalcoloForm?: GraduatoriaRicalcoloForm;
}


export interface GraduatoriaControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Annulla una graduatoria (BOZZA→rimossa; CONFERMATA→ANNULLATA + eventuale revert bando)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}
* @param requestParameters
     */
    annullaGraduatoria(requestParameters: AnnullaGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Conta quante pratiche la regola di eleggibilità selezionerebbe (non persiste)
     * Valuta l\&#39;albero di eleggibilità sulle pratiche ACCETTATE del bando e ritorna                     &#x60;selezionate&#x60; su &#x60;candidate&#x60;, **senza creare nessuna graduatoria**.  Serve a verificare una regola prima di calcolare: una regola formalmente valida                     che non ammette nessuno (valore atteso scritto male, &#x60;IN&#x60; senza valore) non dà                     altrimenti alcun segnale finché non si guarda la graduatoria vuota.  Il body porta il solo albero &#x60;eligibilita&#x60;, nella stessa forma del calcolo: un                     albero invalido risponde 422 esattamente come al calcolo. &#x60;eligibilita&#x60; assente                     o vuota &#x3D; tutte le pratiche ACCETTATE.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/anteprima-eleggibilita
* @param requestParameters
     */
    anteprimaEleggibilitaGraduatoria(requestParameters: AnteprimaEleggibilitaGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaAnteprimaEligibilitaDTO>;

    /**
     * Calcola una nuova graduatoria BOZZA del bando (ranking + eleggibilità inline)
     * La regola di eleggibilità è un ALBERO di nodi annidati (&#x60;eligibilita&#x60;): un nodo GRUPPO combina i propri &#x60;figli&#x60; con il proprio &#x60;logica_join&#x60;, un nodo PREDICATO è una foglia che confronta un valore e NON porta &#x60;logica_join&#x60;. Più elementi in radice sono ammessi e valutati in left-fold. &#x60;eligibilita&#x60; assente o vuota &#x3D; tutte le pratiche accettate del bando.  Il multi-valore si esprime annidando: &#x60;classe IN {1,2}&#x60; si scrive come un GRUPPO OR con due foglie EQ.  I 3 &#x60;override_*&#x60; sono opzionali e sovrascrivono per QUESTA graduatoria i parametri di allocazione del bando; assenti &#x3D; si applica la config del bando. Lo zero è un valore: &#x60;override_budget_totale: 0&#x60; significa \&quot;zero euro\&quot;, non \&quot;non impostato\&quot;.  &#x60;usa_residuo_di&#x60; (opzionale) e\&#39; l\&#39;id di una graduatoria CONFERMATA dello stesso bando: la nuova graduatoria alloca sul RESIDUO del bando dopo quella (e i suoi antenati) invece che sull\&#39;intero. Un override superiore al residuo risponde 422; uguale e\&#39; ammesso. Vedi &#x60;GET .../graduatorie/residui&#x60; per le opzioni.  BREAKING: sostituisce la forma precedente ad array piatto di predicati.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie
* @param requestParameters
     */
    calcolaGraduatoria(requestParameters: CalcolaGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaSnapshotDTO>;

    /**
     * Comunica ai cittadini l\&#39;esito di una graduatoria CONFERMATA (Fase A-bis)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/comunica
* @param requestParameters
     */
    comunicaGraduatoriaEsito(requestParameters: ComunicaGraduatoriaEsitoRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaComunicazioneSummaryDTO>;

    /**
     * Conferma una BOZZA (allocazione + CONFERMATA + supersede/overlap-guard + stato bando)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/conferma
* @param requestParameters
     */
    confermaGraduatoria(requestParameters: ConfermaGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaSnapshotDTO>;

    /**
     * Esegue lo scorrimento del bando (finanzia gli ammessi con il budget liberato)
     * Richiede il disponibile visto in anteprima: se nel frattempo e\&#39; cambiato risponde 409 e non scrive nulla. 422 se la politica di rilascio e\&#39; NESSUNO, se lo stato del bando non ammette lo scorrimento o se non c\&#39;e\&#39; nulla da scorrere. Dopo lo scorrimento servono \&quot;Comunica esito\&quot; e \&quot;Genera voucher\&quot;.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/scorrimento
* @param requestParameters
     */
    eseguiGraduatoriaScorrimento(requestParameters: EseguiGraduatoriaScorrimentoRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaScorrimentoDTO>;

    /**
     * Export della graduatoria come righe JSON (il FE genera l\&#39;.xlsx client-side)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/export
* @param requestParameters
     */
    exportGraduatoria(requestParameters: ExportGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<Array<GraduatoriaRigaDTO>>;

    /**
     * Export «da pubblicare»: la catena in cascata fino a questa graduatoria, numerazione continua, senza dati personali (il FE genera l\&#39;.xlsx client-side)
     * Parte dalla radice della catena e scende alle figlie CONFERMATE; ammessa anche su una graduatoria in BOZZA (catena confermata che la precede + la bozza). Colonne: posizione (continua), sezione (nome della graduatoria), codice_pratica, punteggio, esito. Nessun codice fiscale, nome, ISEE o componenti.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/export-pubblicazione
* @param requestParameters
     */
    exportGraduatoriaPubblicazione(requestParameters: ExportGraduatoriaPubblicazioneRequestParams, extraHttpRequestParams?: any): Observable<Array<GraduatoriaRigaPubblicazioneDTO>>;

    /**
     * Canali su cui partirebbe la comunicazione dell\&#39;esito (solo i nomi, senza testi)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/canali-esito
* @param requestParameters
     */
    getGraduatoriaCanaliEsito(requestParameters: GetGraduatoriaCanaliEsitoRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaCanaliEsitoDTO>;

    /**
     * Dettaglio di una graduatoria (metadati + eleggibilità + flag stale)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}
* @param requestParameters
     */
    getGraduatoriaDettaglio(requestParameters: GetGraduatoriaDettaglioRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaSnapshotDTO>;

    /**
     * Righe paginate di una graduatoria (identità risolta live via pratica_id)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/righe
* @param requestParameters
     */
    getGraduatoriaRighe(requestParameters: GetGraduatoriaRigheRequestParams, extraHttpRequestParams?: any): Observable<PagedModelGraduatoriaRigaDTO>;

    /**
     * Stato e anteprima dello scorrimento del bando (budget liberato dalle revoche)
     * Lo scorrimento finanzia i primi ammessi non finanziati con il budget liberato dalle revoche dei voucher, prima nella graduatoria padre e poi nelle figlie. E\&#39; a livello di BANDO. &#x60;abilitato&#x60; &#x3D; la politica di rilascio del bando non e\&#39; NESSUNO. &#x60;disponibile_importo&#x60;/&#x60;disponibile_posti&#x60; assenti &#x3D; il bando non ha quel limite: sono i valori da rimandare come \&quot;atteso\&quot; all\&#39;esecuzione. &#x60;piano&#x60; e\&#39; l\&#39;anteprima per graduatoria; nulla viene scritto. &#x60;motivo_non_eseguibile&#x60;: NON_ABILITATO, STATO_BANDO_NON_AMMESSO, NULLA_DA_SCORRERE.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/scorrimento
* @param requestParameters
     */
    getGraduatoriaScorrimento(requestParameters: GetGraduatoriaScorrimentoRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaScorrimentoStatoDTO>;

    /**
     * Storico degli scorrimenti eseguiti sul bando
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/scorrimenti
* @param requestParameters
     */
    listGraduatoriaScorrimenti(requestParameters: ListGraduatoriaScorrimentiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelGraduatoriaScorrimentoDTO>;

    /**
     * Lista delle graduatorie del bando (con flag stale sulle BOZZE)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie
* @param requestParameters
     */
    listGraduatorie(requestParameters: ListGraduatorieRequestParams, extraHttpRequestParams?: any): Observable<Array<GraduatoriaListItemDTO>>;

    /**
     * Residuo del bando dopo ciascuna graduatoria CONFERMATA (opzioni di \&quot;usa il residuo di\&quot;)
     * Per ogni graduatoria CONFERMATA del bando, in ordine di conferma, il budget e i posti che resterebbero a una graduatoria figlia che usasse il suo residuo (limiti del bando meno quanto finanziato dalla catena fino a quella graduatoria). &#x60;residuo_budget&#x60;/&#x60;residuo_posti&#x60; assenti &#x3D; il bando non ha quel limite.  &#x60;disponibile&#x3D;false&#x60; indica che la scelta non e\&#39; ammessa; &#x60;motivo_non_disponibile&#x60; e\&#39; &#x60;FIGLIA_CONFERMATA&#x60; (ha gia\&#39; una figlia confermata: va scelta la foglia della catena) o &#x60;BANDO_SENZA_LIMITI&#x60; (ne\&#39; budget ne\&#39; tetto di beneficiari).
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/residui
* @param requestParameters
     */
    listGraduatorieResidui(requestParameters: ListGraduatorieResiduiRequestParams, extraHttpRequestParams?: any): Observable<Array<GraduatoriaResiduoDTO>>;

    /**
     * Ricalcola in-place una BOZZA (preserva id/nome; eleggibilità replace)
     * Un campo assente NON tocca nulla: &#x60;eligibilita&#x60; assente preserva la regola precedente (una lista VUOTA invece la azzera → tutte le accettate), e un &#x60;override_*&#x60; assente preserva quello già impostato. Un body vuoto ricalcola senza cambiare la configurazione.  Quando &#x60;eligibilita&#x60; è presente sostituisce l\&#39;ALBERO intero (replace, non modifica per-nodo). Da qui non si azzera un override per tornare alla config del bando: per farlo si annulla la BOZZA e si ricrea.  BREAKING: &#x60;eligibilita&#x60; è la forma ad albero annidato, non più l\&#39;array piatto.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/ricalcola
* @param requestParameters
     */
    ricalcolaGraduatoria(requestParameters: RicalcolaGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<GraduatoriaSnapshotDTO>;

}
